import { render, staticRenderFns } from "./AttachmentMenu.vue?vue&type=template&id=098b471f&scoped=true"
import script from "./AttachmentMenu.vue?vue&type=script&lang=js"
export * from "./AttachmentMenu.vue?vue&type=script&lang=js"
import style0 from "./AttachmentMenu.vue?vue&type=style&index=0&id=098b471f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098b471f",
  null
  
)

export default component.exports